import type { PropsWithChildren } from "react";

import { QueryClient, QueryClientProvider } from "@jti/rest-api";

const queryClient = new QueryClient();

export const DataLayerComponent: React.FC<PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
